import Vue from 'vue'
import Router from 'vue-router'
import PageDashboardComponent from '@/components/pages/PageDashboardComponent'
import PageCarSearchComponent from '@/components/pages/PageCarSearchComponent'
import PageCreateCarComponent from '@/components/pages/PageCreateCarComponent'
import PageSeoTagsComponent from '@/components/pages/PageSeoTagsComponent'
import PageLogoutComponent from '@/components/pages/PageLogoutComponent'
import PagePublicationComponent from '@/components/pages/PagePublicationComponent'
import TimeLineComponent from '@/components/pages/TimeLineComponent'
import FilePickerComponent from '@/components/custom/FilePickerComponent'
import SessionService from '../utils/SessionService'
import {logger} from '@/utils/Logger'
import PagePromotionsComponent from '@/components/pages/PagePromotionsComponent'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/cars/search'
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: PageDashboardComponent
    },
    {
      path: '/cars/search',
      name: 'search_cars',
      component: PageCarSearchComponent
    },
    {
      path: '/cars/create',
      name: 'create_car',
      component: PageCreateCarComponent,
      meta: {title: 'Alta de vehículo'}
    },
    {
      path: '/cars/:carCode/edit',
      name: 'edit_car',
      component: PageCreateCarComponent
    },
    {
      path: '/seo/tags',
      name: 'seo_tags',
      component: PageSeoTagsComponent
    },
    {
      path: '/logout',
      name: 'logout',
      component: PageLogoutComponent
    },
    {
      path: '/publications/search',
      name: 'publicationSearch',
      component: PagePublicationComponent
    },
    {
      path: '/timeline',
      name: 'timeline',
      component: TimeLineComponent
    },
    {
      path: '/filepicker',
      name: 'filepicker',
      component: FilePickerComponent
    },
    {
      path: '/promotions',
      name: 'promotions',
      component: PagePromotionsComponent
    }
  ]
})

router.beforeEach((to, from, next) => {
  let token = Vue.ls.get('token')
  if ((token === null || SessionService.isJwtTokenExpired(token)) && to.path !== '/login') {
    Vue.ls.set('token', null)
    next('/login')
  } else {
    if (to.meta.hasOwnProperty('title')) {
      document.title = `${to.meta.title} (v${process.env.VERSION})`
    } else {
      document.title = `Multipublicador • Grupo Montalt (v${process.env.VERSION})`
    }

    let roles = SessionService.getRoles(token)

    if (to.name === 'search_cars' && roles.indexOf('ROLE_CMS_SEARCH_VEHICLES') === -1) {
      if (roles.indexOf('ROLE_SHOW_PROMOTIONS') > -1) {
        next('/promotions')
        return
      }
    }

    next()
  }
})

router.afterEach((to, from) => {
  logger.info(`navigate to [${to.path}] from [${from.path}] v(${process.env.VERSION}) Build (${process.env.BUILD})`)
  if (window.getag !== undefined) {
    window.gtag('config', 'UA-127343769-2', {'page_path': to.path})
  }
})

// Google Analytics{
if (window.gtag !== undefined) {
  window.gtag('config', 'UA-127343769-2', {'page_path': router.currentRoute.path})
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js